import React from 'react';
import { connect } from 'react-redux';
import * as Survey from 'survey-react';
import { Bullet } from '../../components/bullet/bullet';
import { Footer } from '../../components/footer/footer';
import HelpComponent from '../../components/help/help';
import { Start } from '../../components/start/start';
import Config from '../../config';
import { translate, translateList } from '../../lib/intl';
import { loanActions } from '../../store/store';
import { extractSurveyData } from '../../survey/survey.utils';
import '../../theme/survey.scss';
import { educational_intake } from './educational_intake';
import './educational_intake.container.scss';

// This line is commented out because ticket MON-388
// import { addSkipButton } from '../../survey/skip_button'

class EducationalIntakeContainer extends React.PureComponent {
  constructor(props) {
    super(props);

    // setup model
    this.model = new Survey.Model(educational_intake(props.device.locale));

    // This line is commented out because ticket MON-388
    //this.model.onAfterRenderPage.add(addSkipButton(this.props.saveIntake, this.props.loan.uuid));

    // restore data
    this.model.data = this.base = {
      ...this.model.data,
      ...this.props.loan.intake,
      guarantor_phone_verified: this.props.loan.intake.guarantor_phone,
      guarantor_2_phone_verified: this.props.loan.intake.guarantor_2_phone,
    };

    try {
      this.model.currentPageNo = this.props.loan.intake.current_page;
    } catch (error) {
      console.error('Sometimes setting the page fails, so starting on title due to error: ', error);
    }

    this.bullets = [];
    this.instructions = [];
    try {
      this.bullets = translateList('start_intake.bullets').map((bullet, idx) =>
        Bullet(translate(bullet), idx)
      );
      this.requirements = translateList('start_intake.requirements').map((req, idx) =>
        Bullet(translate(req), idx)
      );
    } catch (e) {
      console.error(`Unable to translate ${e}, check translation key is added in locale file `);
    }

    // set callbacks
    this.model.onPartialSend.add((survey) => this.onPartialSend(survey));
    this.model.onCompleting.add((survey) => this.onCompleting(survey));

    this.model.startTimer();
    this.model.render();

    this.state = {
      is_started: Config.deployment && Config.deployment === 'eduloan' ? false : true,

      help_count: 0,
      help_time: 0,
      timeOpen: null,
    };
  }

  onPartialSend(survey) {
    this.props.saveIntake(this.props.loan.uuid, extractSurveyData(survey, this.state, this.base));
  }

  async onCompleting(survey) {
    console.log('Complete! ', survey);

    this.model.stopTimer();
    await this.props.saveIntake(
      this.props.loan.uuid,
      extractSurveyData(survey, this.state, this.base),
      true
    );
    await this.props.setPage('checking_intake');
  }

  _openHelp() {
    // counts and keeps track of time
    this.setState({
      help_count: this.state.help_count + 1,
      timeOpen: new Date(),
    });
    this.model.stopTimer();
  }

  _closeHelp() {
    // resets model timer
    this.setState({
      timeOpen: null,
      help_time: this.state.help_time + Math.ceil((new Date() - this.state.timeOpen) / 1000),
    });
    this.model.startTimer();
  }

  render = ({ history, account, device, loan } = this.props) => (
    <div className="educationalIntakeContainer">
      <HelpComponent
        onClose={() => this._closeHelp()}
        onOpen={() => this._openHelp()}
        type="home"
        locale={device.locale}
      />

      {this.state.is_started ? (
        <div className="centerWrapper">
          <Survey.Survey model={this.model} locale={device.locale} />
        </div>
      ) : (
        <div>
          <Start
            stage="intake"
            time={Config.deployment === 'eduloan' ? '15' : '20'}
            onStart={() => this.setState({ is_started: true })}
          >
            <p className="heavy">{translate('start_intake.desc1')}</p>
            <p className="spacer">{translate('start_intake.desc2')}</p>
            {this.bullets}
            {this.instructions}
          </Start>
          <Footer />
        </div>
      )}
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    account: state.account,
    device: state.device,
    loan: state.loan,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    saveIntake: (uuid, assessment, submit) =>
      dispatch(loanActions.saveIntake(uuid, assessment, submit)),
    setPage: (page) => dispatch(loanActions.setPage(page)),
  };
};

const connectedContainer = connect(mapStateToProps, mapDispatchToProps)(EducationalIntakeContainer);

export { connectedContainer as EducationalIntakeContainer };
